import { extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import { useSafeThemeUI, isFlatDesign, FlexInline, Text, ListItem, ListItemText } from '@costar/theme-ui';
import match from 'autosuggest-highlight/match';
import parse from 'autosuggest-highlight/parse';
import React, { useMemo } from 'react';

var styleOverride = {
  whiteSpace: 'pre',
  fontWeight: 400
};
var styleOverrideBold = {
  whiteSpace: 'pre',
  fontWeight: 700
};
var HighlightListItem = function HighlightListItem(props) {
  var wrapperProps = props.wrapperProps,
    option = props.option,
    _props$inputValue = props.inputValue,
    inputValue = _props$inputValue === void 0 ? '' : _props$inputValue;
  var theme = useSafeThemeUI(props);
  var isFlatDesign$1 = isFlatDesign(theme);
  var labelParts = useMemo(function () {
    var labelMatches = match(option.label, inputValue);
    return parse(option.label, labelMatches);
  }, [inputValue, option.label]);
  var secondaryText = typeof option.secondary === 'string' ? option.secondary : '';
  var secondaryParts = useMemo(function () {
    var secondaryMatches = match(secondaryText, inputValue);
    return parse(secondaryText, secondaryMatches);
  }, [inputValue, secondaryText]);
  var primary = useMemo(function () {
    return /*#__PURE__*/React.createElement(FlexInline, {
      className: "csg-tui-list-item-text-primary",
      minWidth: "0px",
      flexGrow: 1,
      alignItems: "baseline"
    }, /*#__PURE__*/React.createElement(Text, {
      ellipsis: true
    }, labelParts.map(function (part, index) {
      return /*#__PURE__*/React.createElement("span", {
        key: index,
        style: part.highlight ? styleOverrideBold : styleOverride
      }, part.text);
    })));
  }, [labelParts]);
  var secondary = useMemo(function () {
    return secondaryText ? /*#__PURE__*/React.createElement(FlexInline, {
      className: "csg-tui-list-item-text-secondary",
      minWidth: "0px",
      flexGrow: 1,
      alignItems: "baseline",
      fontSize: "0.875em",
      fontWeight: isFlatDesign$1 ? undefined : 'light'
    }, /*#__PURE__*/React.createElement(Text, {
      ellipsis: true
    }, secondaryParts.map(function (part, index) {
      return /*#__PURE__*/React.createElement("span", {
        key: index,
        style: part.highlight ? styleOverrideBold : styleOverride
      }, part.text);
    }))) : option.secondary;
  }, [isFlatDesign$1, option.secondary, secondaryParts, secondaryText]);
  return /*#__PURE__*/React.createElement(ListItem, _extends({
    divider: true
  }, wrapperProps), /*#__PURE__*/React.createElement(ListItemText, {
    disableTextWrap: true,
    primary: primary,
    secondary: secondary
  }));
};
function renderHighlightMatchSearchItem(props, option, state) {
  var inputValue = state.inputValue;
  return /*#__PURE__*/React.createElement(HighlightListItem, {
    wrapperProps: props,
    option: option,
    inputValue: inputValue
  });
}

export default renderHighlightMatchSearchItem;
//# sourceMappingURL=highlight-search-match-item.esm.js.map
